import { z } from 'zod';
import { slugBaseSchema } from '../const/slugBaseSchema';
import { uuidSchema } from '../const/uuidSchema';

export const brandInputSchema = z.object({
    id: uuidSchema.optional(),

    name: z
        .string({ required_error: 'укажите название бренда', invalid_type_error: 'название должно быть строкой' })
        .trim()
        .min(1, 'введите название бренда')
        .max(300, 'название не должно превышать 300 символов'),

    baseSlug: slugBaseSchema,

    imageId: uuidSchema.optional().nullable(),
});

export type BrandInputSchema = z.infer<typeof brandInputSchema>;
